import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function CompetitiveEdge() {
  const edges = ['Verified practitioner network', 'Women-first wellness focus', 'AI-powered personalization', 'Holistic + clinical integration', 'Community + marketplace hybrid'];
  return <Section background="charcoal" className="text-ivory" data-id="element-114">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-115">
        <div data-id="element-116">
          <FadeIn data-id="element-117">
            <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-118">
              Where Trust Meets{' '}
              <span className="italic text-purple-700" data-id="element-119">Intelligence</span>
            </h2>
            <p className="text-lg text-ivory/70 mb-8" data-id="element-120">
              We are not just another directory. We are a curated, intelligent
              infrastructure designed specifically for the nuances of women's
              health.
            </p>
          </FadeIn>
        </div>

        <div data-id="element-121">
          <div className="space-y-6" data-id="element-122">
            {edges.map((edge, idx) => <FadeIn key={idx} delay={idx * 150} data-id="element-123">
                <div className="flex items-center p-4 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm" data-id="element-124">
                  <CheckCircle2 className="w-6 h-6 text-purple-400 mr-4 flex-shrink-0" data-id="element-125" />
                  <span className="text-lg font-medium tracking-wide" data-id="element-126">
                    {edge}
                  </span>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </Section>;
}